import React, { Component } from "react";
import LayoutPage from "./LayoutIdentificationPages";

class SplashScreen extends Component {
  render() {
    return (
      <LayoutPage>
        <h1 style={{ width: '100%', textAlign: 'center' }}>
          Chargement de l'application...
        </h1>
      </LayoutPage>
    );
  }
}

export default SplashScreen;
